export default {
  "Start": {
    "fr": "Accueil",
    "it": "Inizio",
    "en": "Home"
  },
  "Tägliche Arbeit": {
    "fr": "Travail quotidien",
    "it": "Lavoro quotidiano",
    "en": "Daily work"
  },
  "Geöffneter Bereich": {
    "fr": "Section ouverte",
    "it": "Sezione aperta",
    "en": "Current area"
  },
  "Alle Bereiche anzeigen": {
    "fr": "Afficher toutes les sections",
    "it": "Mostra tutte le sezioni",
    "en": "Show all areas"
  },
  "Weniger Bereiche anzeigen": {
    "fr": "Afficher moins de sections",
    "it": "Mostra meno sezioni",
    "en": "Show fewer areas"
  },
  "Weitere Bereiche": {
    "fr": "Autres sections",
    "it": "Altre sezioni",
    "en": "More areas"
  },
  "Website-Projekte": {
    "fr": "Projets de sites web",
    "it": "Progetti web",
    "en": "Website projects"
  },
  "Kundenwünsche": {
    "fr": "Demandes des clients",
    "it": "Richieste dei clienti",
    "en": "Customer wishes"
  },
  "Mein Arbeitsplatz": {
    "fr": "Mon espace de travail",
    "it": "Il mio spazio di lavoro",
    "en": "My workspace"
  },
  "Team-Arbeitsplatz": {
    "fr": "Espace de travail de l’équipe",
    "it": "Spazio di lavoro del team",
    "en": "Team workspace"
  },
  "Kunden öffnen": {
    "fr": "Ouvrir les clients",
    "it": "Apri i clienti",
    "en": "Open clients"
  },
  "Aufträge, Vorschauen und Dokumente prüfen.": {
    "fr": "Vérifiez les projets, aperçus et documents.",
    "it": "Controlla progetti, anteprime e documenti.",
    "en": "Review projects, previews and documents."
  },
  "Aufgaben öffnen": {
    "fr": "Ouvrir les tâches",
    "it": "Apri le attività",
    "en": "Open tasks"
  },
  "Zuständigkeit und nächsten Schritt prüfen.": {
    "fr": "Vérifiez la personne responsable et la prochaine étape.",
    "it": "Controlla il responsabile e il prossimo passo.",
    "en": "Check the owner and next step."
  },
  "Kundenwünsche öffnen": {
    "fr": "Ouvrir les demandes clients",
    "it": "Apri le richieste dei clienti",
    "en": "Open customer wishes"
  },
  "Neue Wünsche lesen und weiterbearbeiten.": {
    "fr": "Lisez les nouvelles demandes et traitez-les.",
    "it": "Leggi ed elabora le nuove richieste.",
    "en": "Read and process new wishes."
  },
  "Rechnungen öffnen": {
    "fr": "Ouvrir les factures",
    "it": "Apri le fatture",
    "en": "Open invoices"
  },
  "Rechnungen und ihren Status ansehen.": {
    "fr": "Consultez les factures et leur statut.",
    "it": "Visualizza le fatture e il loro stato.",
    "en": "View invoices and their status."
  },
  "Support öffnen": {
    "fr": "Ouvrir le support",
    "it": "Apri il supporto",
    "en": "Open support"
  },
  "Offene Fragen der Kunden ansehen.": {
    "fr": "Consultez les questions ouvertes des clients.",
    "it": "Visualizza le domande aperte dei clienti.",
    "en": "View customers’ open questions."
  },
  "Änderung wünschen": {
    "fr": "Demander une modification",
    "it": "Richiedi una modifica",
    "en": "Request a change"
  },
  "Beschreiben Sie, was Sie ändern möchten.": {
    "fr": "Décrivez ce que vous souhaitez modifier.",
    "it": "Descriva cosa desidera modificare.",
    "en": "Describe what you would like to change."
  },
  "Freigaben ansehen": {
    "fr": "Voir les validations",
    "it": "Visualizza le approvazioni",
    "en": "View approvals"
  },
  "Entwürfe prüfen und Ihre Rückmeldung geben.": {
    "fr": "Vérifiez les propositions et donnez votre avis.",
    "it": "Controlli le bozze e dia il Suo parere.",
    "en": "Review drafts and give your feedback."
  },
  "Hilfe bekommen": {
    "fr": "Obtenir de l’aide",
    "it": "Ricevi aiuto",
    "en": "Get help"
  },
  "Eine Frage stellen oder ein Problem melden.": {
    "fr": "Posez une question ou signalez un problème.",
    "it": "Ponga una domanda o segnali un problema.",
    "en": "Ask a question or report a problem."
  },
  "Dateien öffnen": {
    "fr": "Ouvrir les fichiers",
    "it": "Apri i file",
    "en": "Open files"
  },
  "Ihre Dokumente und Dateien ansehen.": {
    "fr": "Consultez vos documents et fichiers.",
    "it": "Visualizzi i Suoi documenti e file.",
    "en": "View your documents and files."
  },
  "Website ansehen": {
    "fr": "Voir le site web",
    "it": "Visualizza il sito web",
    "en": "View website"
  },
  "Den hinterlegten Website-Stand ansehen.": {
    "fr": "Consultez l’état enregistré de votre site.",
    "it": "Visualizzi lo stato registrato del sito.",
    "en": "View the recorded website status."
  },
  "Was möchten Sie erledigen?": {
    "fr": "Que souhaitez-vous faire ?",
    "it": "Cosa desidera fare?",
    "en": "What would you like to do?"
  },
  "Was möchtest du erledigen?": {
    "fr": "Que souhaites-tu faire ?",
    "it": "Cosa vuoi fare?",
    "en": "What would you like to do?"
  },
  "So geht es": {
    "fr": "Comment faire",
    "it": "Come funziona",
    "en": "How it works"
  },
  "Anleitung schliessen": {
    "fr": "Fermer le guide",
    "it": "Chiudi la guida",
    "en": "Close guide"
  },
  "Öffnen Sie den passenden Bereich.": {
    "fr": "Ouvrez la section souhaitée.",
    "it": "Apra la sezione desiderata.",
    "en": "Open the relevant area."
  },
  "Lesen Sie die Angaben und ergänzen Sie Ihren Wunsch.": {
    "fr": "Lisez les informations et précisez votre demande.",
    "it": "Legga le informazioni e completi la Sua richiesta.",
    "en": "Read the information and add your request."
  },
  "Prüfen Sie vor dem Senden oder Freigeben den Inhalt.": {
    "fr": "Vérifiez le contenu avant d’envoyer ou de valider.",
    "it": "Controlli il contenuto prima di inviare o approvare.",
    "en": "Check the content before sending or approving."
  },
  "Kunden oder Auftrag öffnen.": {
    "fr": "Ouvrir un client ou un projet.",
    "it": "Apri un cliente o un progetto.",
    "en": "Open a client or project."
  },
  "Nächste Aufgabe und Zuständigkeit prüfen.": {
    "fr": "Vérifier la prochaine tâche et la personne responsable.",
    "it": "Controlla il prossimo compito e il responsabile.",
    "en": "Check the next task and its owner."
  },
  "Arbeit bearbeiten, speichern und Ergebnis prüfen.": {
    "fr": "Effectuer le travail, enregistrer et vérifier le résultat.",
    "it": "Svolgi il lavoro, salva e controlla il risultato.",
    "en": "Do the work, save and check the result."
  },
  "Firma suchen und Details ansehen.": {
    "fr": "Cherchez une entreprise et consultez ses informations.",
    "it": "Cerca un’azienda e visualizza i dettagli.",
    "en": "Find a company and view its details."
  },
  "Kunden öffnen und Firma auswählen.": {
    "fr": "Ouvrir les clients et choisir une entreprise.",
    "it": "Apri i clienti e scegli un’azienda.",
    "en": "Open clients and choose a company."
  },
  "Angaben und Status ansehen.": {
    "fr": "Consulter les informations et le statut.",
    "it": "Visualizza i dettagli e lo stato.",
    "en": "View details and status."
  },
  "Bei Fragen das Betreuungsteam kontaktieren.": {
    "fr": "Contacter l’équipe en cas de question.",
    "it": "Contatta il team in caso di domande.",
    "en": "Contact the care team if you have questions."
  },
  "Erreichbar": {
    "fr": "Accessible",
    "it": "Raggiungibile",
    "en": "Reachable"
  },
  "Nicht aktuell geprüft": {
    "fr": "Pas de vérification récente",
    "it": "Non verificato di recente",
    "en": "Not recently checked"
  },
  "Erreichbarkeit geprüft": {
    "fr": "Accessibilité vérifiée",
    "it": "Raggiungibilità verificata",
    "en": "Reachability checked"
  },
  "Website erreichbar": {
    "fr": "Site web accessible",
    "it": "Sito raggiungibile",
    "en": "Website reachable"
  },
  "Aktueller Status offen": {
    "fr": "Statut actuel non vérifié",
    "it": "Stato attuale da verificare",
    "en": "Current status unverified"
  },
  "Bei der letzten Prüfung erreichbar.": {
    "fr": "Accessible lors de la dernière vérification.",
    "it": "Raggiungibile all’ultima verifica.",
    "en": "Reachable at the last check."
  },
  "Eine aktuelle Prüfung ist noch offen.": {
    "fr": "Une vérification récente reste à faire.",
    "it": "Manca una verifica recente.",
    "en": "A current check is still pending."
  },
  "Kein nächster Schritt hinterlegt.": {
    "fr": "Aucune prochaine étape enregistrée.",
    "it": "Nessun prossimo passo registrato.",
    "en": "No next step recorded."
  },
  "Team, Kennzahlen und weitere Übersichten": {
    "fr": "Équipe, indicateurs et autres aperçus",
    "it": "Team, indicatori e altre panoramiche",
    "en": "Team, figures and more overviews"
  },
  "Konfiguriert": {
    "fr": "Configuré",
    "it": "Configurato",
    "en": "Configured"
  },
  "Live-Status offen": {
    "fr": "État actuel non vérifié",
    "it": "Stato attuale non verificato",
    "en": "Live status unverified"
  },
  "Offene Kundenwünsche": {
    "fr": "Demandes clients ouvertes",
    "it": "Richieste clienti aperte",
    "en": "Open customer wishes"
  },
  "Quelle: gespeicherte Connector-Prüfungen": {
    "fr": "Source : vérifications enregistrées des connecteurs",
    "it": "Fonte: verifiche dei connettori salvate",
    "en": "Source: saved connector checks"
  },
  "Keine abgefangenen Fehler in den letzten 7 Tagen gemeldet.": {
    "fr": "Aucune erreur interceptée signalée ces 7 derniers jours.",
    "it": "Nessun errore intercettato segnalato negli ultimi 7 giorni.",
    "en": "No caught errors reported in the last 7 days."
  },
  "Letztes In-App-Backup": {
    "fr": "Dernière sauvegarde interne",
    "it": "Ultimo backup interno",
    "en": "Last in-app backup"
  },
  "Vollsicherung und Zeitplan": {
    "fr": "Sauvegarde complète et calendrier",
    "it": "Backup completo e pianificazione",
    "en": "Full backup and schedule"
  },
  "Unter Sicherheit & QA prüfen": {
    "fr": "À vérifier dans Sécurité & QA",
    "it": "Verifica in Sicurezza e QA",
    "en": "Check under Security & QA"
  },
  "Weitere Angaben und Verlauf": {
    "fr": "Autres informations et historique",
    "it": "Altre informazioni e cronologia",
    "en": "More details and history"
  },
  "Team oder Kunde": {
    "fr": "Équipe ou client",
    "it": "Team o cliente",
    "en": "Team or customer"
  },
  "Zuständige Person": {
    "fr": "Personne responsable",
    "it": "Persona responsabile",
    "en": "Person responsible"
  },
  "Zuerst Kunde auswählen": {
    "fr": "Choisissez d’abord un client",
    "it": "Seleziona prima un cliente",
    "en": "Choose a customer first"
  },
  "Team wird geladen…": {
    "fr": "Chargement de l’équipe…",
    "it": "Caricamento del team…",
    "en": "Loading team…"
  },
  "Team konnte nicht geladen werden. Bitte erneut öffnen.": {
    "fr": "Impossible de charger l’équipe. Veuillez rouvrir.",
    "it": "Impossibile caricare il team. Riapri.",
    "en": "Could not load the team. Please reopen."
  },
  "Nicht verfügbar": {
    "fr": "Indisponible",
    "it": "Non disponibile",
    "en": "Unavailable"
  },
  "Aufgaben konnten nicht geladen werden.": {
    "fr": "Impossible de charger les tâches.",
    "it": "Impossibile caricare le attività.",
    "en": "Could not load tasks."
  },
  "Wer macht was bis wann? Aufgaben zuweisen und den nächsten Schritt festhalten.": {
    "fr": "Qui fait quoi et pour quand ? Attribuez les tâches et définissez la prochaine étape.",
    "it": "Chi fa cosa ed entro quando? Assegna le attività e definisci il prossimo passo.",
    "en": "Who does what by when? Assign tasks and record the next step."
  },
  "Sehen, worauf Kunden warten und was bereits freigegeben wurde.": {
    "fr": "Consultez les attentes des clients et les validations déjà reçues.",
    "it": "Vedi cosa attendono i clienti e cosa è già stato approvato.",
    "en": "See what customers are waiting for and what has already been approved."
  },
  "Freigaben filtern": {
    "fr": "Filtrer les validations",
    "it": "Filtra le approvazioni",
    "en": "Filter approvals"
  },
  "Freigabe ausstehend": {
    "fr": "Validation en attente",
    "it": "Approvazione in attesa",
    "en": "Approval pending"
  },
  "Rückmeldung ausstehend": {
    "fr": "Réponse en attente",
    "it": "Risposta in attesa",
    "en": "Feedback pending"
  },
  "Vom Kunden freigegeben": {
    "fr": "Validé par le client",
    "it": "Approvato dal cliente",
    "en": "Approved by the customer"
  },
  "Kundenfreigabe ausstehend": {
    "fr": "Validation du client en attente",
    "it": "Approvazione del cliente in attesa",
    "en": "Customer approval pending"
  },
  "Im Kunden-Cockpit anzeigen": {
    "fr": "Afficher dans l’espace client",
    "it": "Mostra nel portale cliente",
    "en": "Show in customer cockpit"
  },
  "Kundenansicht: Freigaben und Rückmeldungen erteilt der Kunde selbst.": {
    "fr": "Vue client : seul le client donne ses validations et ses réponses.",
    "it": "Vista cliente: approvazioni e risposte sono fornite dal cliente stesso.",
    "en": "Customer view: approvals and feedback are submitted by the customer."
  },
  "Aufgabe erfasst.": {
    "fr": "Tâche enregistrée.",
    "it": "Attività registrata.",
    "en": "Task recorded."
  },
  "Alle Aufgaben": {
    "fr": "Toutes les tâches",
    "it": "Tutte le attività",
    "en": "All tasks"
  },
  "Meine Aufgaben": {
    "fr": "Mes tâches",
    "it": "Le mie attività",
    "en": "My tasks"
  },
  "Entwürfe freigeben": {
    "fr": "Valider les propositions",
    "it": "Approva le proposte",
    "en": "Approve designs"
  },
  "Aufgaben & Freigaben": {
    "fr": "Tâches et validations",
    "it": "Attività e approvazioni",
    "en": "Tasks and approvals"
  },
  "Aufgaben prüfen und Ihre Rückmeldung geben.": {
    "fr": "Consultez les tâches et donnez votre réponse.",
    "it": "Controlla le attività e invia la tua risposta.",
    "en": "Review tasks and give your feedback."
  },
  "Nächster Schritt": {
    "fr": "Prochaine étape",
    "it": "Prossimo passo",
    "en": "Next step"
  },
  "Arbeit starten": {
    "fr": "Commencer le travail",
    "it": "Inizia il lavoro",
    "en": "Start work"
  },
  "Zuständigkeit und nächsten Schritt prüfen, dann beginnen.": {
    "fr": "Vérifiez le responsable et la prochaine étape, puis commencez.",
    "it": "Controlla il responsabile e il prossimo passo, poi inizia.",
    "en": "Check the owner and next step, then start."
  },
  "Ergebnis vorbereiten": {
    "fr": "Préparer le résultat",
    "it": "Prepara il risultato",
    "en": "Prepare the result"
  },
  "Aufgabe bearbeiten und das Ergebnis zur internen Prüfung geben.": {
    "fr": "Traitez la tâche puis soumettez le résultat à la vérification interne.",
    "it": "Svolgi il lavoro e invia il risultato alla verifica interna.",
    "en": "Do the work and submit the result for internal review."
  },
  "Zur internen Prüfung": {
    "fr": "Pour vérification interne",
    "it": "Alla verifica interna",
    "en": "Submit for internal review"
  },
  "Kunde ist am Zug": {
    "fr": "Au client de répondre",
    "it": "Tocca al cliente",
    "en": "Waiting on customer"
  },
  "Die Kundenfreigabe steht aus. Erst danach kann die Aufgabe abgeschlossen werden.": {
    "fr": "La validation du client est en attente. La tâche pourra ensuite être clôturée.",
    "it": "Si attende l’approvazione del cliente prima di chiudere l’attività.",
    "en": "Customer approval is pending. The task can only be completed afterwards."
  },
  "Die Rückmeldung des Kunden steht aus. Sie ist noch keine Freigabe.": {
    "fr": "La réponse du client est en attente. Ce n’est pas encore une validation.",
    "it": "Si attende la risposta del cliente. Non è ancora un’approvazione.",
    "en": "Customer feedback is pending. It is not an approval yet."
  },
  "Ergebnis und Checkliste prüfen, danach abschliessen.": {
    "fr": "Vérifiez le résultat et la liste, puis clôturez la tâche.",
    "it": "Controlla il risultato e la lista, poi chiudi l’attività.",
    "en": "Review the result and checklist, then complete the task."
  },
  "Aufgabe abschliessen": {
    "fr": "Clôturer la tâche",
    "it": "Chiudi l’attività",
    "en": "Complete task"
  },
  "Ergebnis prüfen": {
    "fr": "Vérifier le résultat",
    "it": "Verifica il risultato",
    "en": "Review the result"
  },
  "Bei Bedarf Kundenfreigabe anfordern. Interne Aufgaben können nach der Prüfung abgeschlossen werden.": {
    "fr": "Demandez si nécessaire la validation du client. Les tâches internes peuvent être clôturées après vérification.",
    "it": "Se necessario richiedi l’approvazione del cliente. Le attività interne possono essere chiuse dopo la verifica.",
    "en": "Request customer approval if needed. Internal tasks can be completed after review."
  },
  "Diese Aufgabe liegt im Archiv. Sie kann bei Bedarf wieder geöffnet werden.": {
    "fr": "Cette tâche est archivée. Elle peut être rouverte si nécessaire.",
    "it": "Questa attività è archiviata. Può essere riaperta se necessario.",
    "en": "This task is archived. It can be reopened if needed."
  },
  "Die Aufgabe ist abgeschlossen. Verlauf und Freigabe bleiben nachvollziehbar.": {
    "fr": "La tâche est clôturée. L’historique et la validation restent consultables.",
    "it": "L’attività è chiusa. Cronologia e approvazione restano consultabili.",
    "en": "The task is complete. Its history and approval remain traceable."
  },
  "Ungespeicherte Änderungen": {
    "fr": "Modifications non enregistrées",
    "it": "Modifiche non salvate",
    "en": "Unsaved changes"
  },
  "Gespeicherter Stand": {
    "fr": "Version enregistrée",
    "it": "Versione salvata",
    "en": "Saved version"
  },
  "Wird gespeichert…": {
    "fr": "Enregistrement…",
    "it": "Salvataggio…",
    "en": "Saving…"
  },
  "Änderungen speichern": {
    "fr": "Enregistrer les modifications",
    "it": "Salva le modifiche",
    "en": "Save changes"
  },
  "Ihre Eingaben bleiben erhalten. Prüfen Sie den Hinweis und versuchen Sie es erneut.": {
    "fr": "Vos saisies sont conservées. Vérifiez le message et réessayez.",
    "it": "I dati inseriti sono conservati. Controlla il messaggio e riprova.",
    "en": "Your input is kept. Check the message and try again."
  },
  "Gespeicherten Stand neu laden": {
    "fr": "Recharger la version enregistrée",
    "it": "Ricarica la versione salvata",
    "en": "Reload saved version"
  },
  "Ungespeicherte Änderungen verwerfen?": {
    "fr": "Abandonner les modifications non enregistrées ?",
    "it": "Scartare le modifiche non salvate?",
    "en": "Discard unsaved changes?"
  },
  "Neue Freigabe anfordern": {
    "fr": "Demander une nouvelle validation",
    "it": "Richiedi una nuova approvazione",
    "en": "Request new approval"
  },
  "Alle Änderungen oben gemeinsam speichern oder den nächsten Schritt ausführen.": {
    "fr": "Enregistrez toutes les modifications en haut ou passez à l’étape suivante.",
    "it": "Salva tutte le modifiche in alto oppure esegui il prossimo passo.",
    "en": "Save all changes together at the top or continue with the next step."
  },
  "Weitere Aktionen": {
    "fr": "Autres actions",
    "it": "Altre azioni",
    "en": "More actions"
  }
};
